export function showhidePassword() {
  // Obtener todos los botones que alternan la visibilidad de la contraseña
  const togglePasswordButtons = document.querySelectorAll('.toggle-password');

  togglePasswordButtons.forEach(button => {
    button.addEventListener('click', function() {
      // Obtener el span con el icono
      const icon = this.querySelector('.material-icons-outlined');
      
      // Obtener el input asociado usando el elemento anterior
      const input = this.closest('.form-group').querySelector('.form-input');
      if (input) { 
        // Alternar el tipo de input asociado
        if (input.getAttribute('type') === 'password') {
          input.setAttribute('type', 'text');
          icon.textContent = 'visibility_off'; // Cambiar el icono a "visibility_off"
        } else {
          input.setAttribute('type', 'password');
          icon.textContent = 'visibility'; // Cambiar el icono a "visibility"
        }
      } 
    });
  });
}
